import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group">
      <circle id="Oval" cx="16" cy="16" r="15" fill="white" stroke="#D80000" strokeWidth="2" />
      <path
        id="Vector"
        d="M11.5653 9.125H20.93C21.242 9.125 21.4953 9.37834 21.4953 9.69038V22.31C21.4953 22.6218 21.2422 22.875 20.9304 22.875H11.5653C11.2532 22.875 10.9999 22.6217 10.9999 22.3096V9.69038C10.9999 9.37834 11.2532 9.125 11.5653 9.125Z"
        fill="#D80000"
      />
    </g>
  </svg>
);

const IconRedCardWithCircle = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconRedCardWithCircle;
